import { Link } from 'react-router';
import { SanitySideItem } from '../../../../@types';
import { sanityImageURL } from '../../../../helpers/sanity';
import Box from '@mui/material/Box';

type CMSTopItemProps = {
  item: SanitySideItem;
};

const CMSTopItem = ({ item }: CMSTopItemProps) => {
  const src = sanityImageURL(item?.image, { w: 480 });

  return (
    <Link to={item?.callToActionURL ?? '/'}>
      <Box
        component='img'
        alt={item.title}
        src={src}
        title={item.title}
        sx={{ height: '150px', width: 'auto', objectFit: 'cover' }}
      />
    </Link>
  );
};

export default CMSTopItem;
